// Root path
export const ROOT_PATH = '/biblioteca'

//Padlets path
export const PADLET_PATH = ROOT_PATH + '/padlet'

// path to force user sign in
export const LOGIN_BY_JWT_PATH = '/direct-login/'

// path for users coming from combo
export const LANDING_COMBO_PATH = '/landing_combo/'

// path for users coming from freemium sign-up form
export const LANDING_FREEMIUM_PATH = '/landing_freemium'

//path for users with temporary access
export const TRIAL_START_PATH = '/trial/acessar'
export const TRIAL_END_PATH = '/trial/expirado'
export const TRIAL_SELF_REGISTER_PATH = '/registrar/codigo'
export const TRIAL_SELF_REGISTER_WITH_CODE_PATH = (code?: string) =>
  `/registrar/codigo/${code ? code : ':code'}`
export const TRIAL_SUCCESS_SELF_REGISTER_PATH = (code?: string) =>
  `/registrar/codigo/${code ? code : ':code'}/sucesso`

export const TRIAL_VOUCHER_SELF_REGISTER_WITH_CODE_PATH = (code?: string) =>
  `/registrar/voucher/${code ? code : ':code'}`
export const TRIAL_VOUCHER_SUCCESS_SELF_REGISTER_PATH = (code?: string) =>
  `/registrar/voucher/${code ? code : ':code'}/sucesso`

// Site paths
export const PAYMENT_PATH = ROOT_PATH + '/pagamento'
export const PENDING_PAYMENT_PATH = ROOT_PATH + '/pagamento-pendente'
export const PAYMENT_PATH_QUERY_STRING = (origin?: string) =>
  `${PAYMENT_PATH}?utm_source=web&utm_medium=${origin}&utm_campaign=renovacao_antecipada_2025`

export const BOOKFAIR_PATH = '/book-fair'
export const BOOKFAIR_SUCCESS_PATH = BOOKFAIR_PATH + '/success'
export const BOOKFAIR_SCHOOL_CONFIRMATION_LOGIN = (code?: string) =>
  `${BOOKFAIR_PATH}/${code || ':code'}`
export const BOOKFAIR_SCHOOL_UNIT_SELECTION = (code?: string) =>
  `${BOOKFAIR_PATH}/${code || ':code'}/unidade`
export const BOOKFAIR_SCHOOL_ACCESS_RETRIEVAL = (
  code?: string,
  entityId?: string | number
) =>
  `${BOOKFAIR_PATH}/${code || ':code'}/resgatar-acesso${
    entityId ? `?entityId=${entityId}` : ''
  }`

export const EXPLORE_PATH = ROOT_PATH + '/explorar'

export const FAMILY_INVITE_PATH = ROOT_PATH + '/chamar-responsavel'
export const FAMILY_INVITE_PASS_PHONE_PATH =
  FAMILY_INVITE_PATH + '/passar-celular'

export const CATEGORY_PATH = (name?: string) =>
  `${ROOT_PATH}/categoria/${name || ':name'}`
export const INDICATED_PATH = ROOT_PATH + '/indicados'

export const MY_READINGS_MODULAR_PATH = ROOT_PATH + '/minhas-leituras'
export const MY_READINGS_MODULAR_READING_PATH =
  MY_READINGS_MODULAR_PATH + '/lendo'
export const MY_READINGS_MODULAR_READ_PATH = MY_READINGS_MODULAR_PATH + '/lidos'
export const MY_READINGS_MODULAR_INDICATED_PATH =
  MY_READINGS_MODULAR_PATH + '/indicados'
export const MY_READINGS_MODULAR_FAVORITES_PATH =
  MY_READINGS_MODULAR_PATH + '/favoritos'
export const APP_V2_MY_READINGS_PATH = '/app-v2/my-readings'

export const COLLECTION_PATH = (id?: string | number) =>
  `${ROOT_PATH}/colecao/${id || ':id'}`
export const PUBLISHER_PATH = (publisherName?: string | number) =>
  `${ROOT_PATH}/editora/${publisherName || ':publisherName'}`
export const AUTHOR_PATH = (authorName?: string | number) =>
  `${ROOT_PATH}/autor/${authorName || ':authorName'}`
export const COLLECTION_SENTIR_PATH = (id?: string | number) =>
  `${SENTIR_HOME_ROOT_PATH}/colecao/${id || ':id'}`
export const JOURNEY_EVALUATION = ROOT_PATH + '/avaliacao-leitora'
export const READER_RATING = (currentStep?: string) =>
  `${JOURNEY_EVALUATION}/${currentStep || ':currentStep'}`
export const RECORDING_AUDIO = (id?: string | number) =>
  `${JOURNEY_EVALUATION}/comecar-audio-${id || ':id'}`

// Reading Fluency paths
export const READING_FLUENCY = ROOT_PATH + '/fluencia-leitora'
export const READING_FLUENCY_APP_V2 = '/app-v2/reading-fluency'

// SEARCH route is being used in the cypress test, if it changes or is removed it is necessary to change the e2e test (frontend/cypress/e2e/search.cy.js)
export const SEARCH_PATH_ROOT = ROOT_PATH + '/busca'
export const SEARCH_PATH = (term?: string) =>
  `${SEARCH_PATH_ROOT}/${term || ':term?'}`
export const SEARCH_PATH_OLD_TEMP = (term?: string) =>
  `${ROOT_PATH}/busca--old/${term || ':term'}`

export const LOGIN_PATH = '/login'
export const LOGIN_V2_PATH = '/login-v2'
export const LOGOUT_PATH = '/logout'
export const RECOVER_ACCESS_PATH = LOGIN_PATH + '/recuperar-acesso'
export const RECOVER_ACCESS_CONFIRM_SENT_PATH =
  LOGIN_PATH + '/recuperar-acesso/enviado'
export const RECOVER_PASSWORD_PATH = LOGIN_PATH + '/recuperar-senha'
export const RESET_PASSWORD_PATH = ROOT_PATH + '/resetar-senha'
export const MY_ACCESS_PATH = ROOT_PATH + '/meu-acesso'
export const MY_NOTIFICATION_PREFERENCES_PATH = ROOT_PATH + '/notificacoes'
export const MY_ACCOUNT_PATH = ROOT_PATH + '/minha-conta'
export const MY_BOOKS_PATH = ROOT_PATH + '/meus-livros'
export const LANGUAGES_SWITCHER_PATH = ROOT_PATH + '/language-switcher'

export const FOREST_PATH = ROOT_PATH + '/floresta'
export const FOREST_TREES_PATH = ROOT_PATH + '/floresta/arvores'
export const LEAGUE_PATH = ROOT_PATH + '/liga'
export const LEAGUE_TUTORIAL_PATH = ROOT_PATH + '/liga/tutorial'
export const FIRST_RESET_PASSWORD_PATH =
  ROOT_PATH + '/primeiro-acesso-alterar-senha'

// ACTIVITIES route is being used in the cypress test, if it changes or is removed it is necessary to change the e2e test (frontend/cypress/e2e/smokeReader.cy.js)
export const ACTIVITIES_PATH = ROOT_PATH + '/atividades'
export const RECOMMENDATIONS_PATH = '/app-v2/recommendations'
export const QUIZ_PATH = (quizId?: string | number) =>
  `/app-v2/quiz/${quizId || ':quizId'}`

export const RUNNING_RECORDS_APP_V2_PATH = '/app-v2/running-records'
export const ACTIVITIES_V3_PATH = '/app-v2/activities'

export const ACTIVITIES_DO_ACTIVITY_PATH = (
  id?: string | number,
  type?: string
) => `${ROOT_PATH}/atividades/fazer-atividade/${id || ':id'}/${type || ':type'}`
export const ACTIVITIES_DO_ACTIVITY_PATH_V2 = (
  id?: string | number,
  type?: string
) =>
  `${ROOT_PATH}/atividades/fazer-atividade-v2/${id || ':id'}/${type || ':type'}`
export const ACTIVITIES_FINISHED_PATH = (id?: string | number) =>
  `${ROOT_PATH}/atividades/atividade-finalizada/${id || ':id'}`

export const ACTIVITIES_SEE_CORRECTED_ACTIVITY_PATH = (id?: string | number) =>
  `${ROOT_PATH}/atividades/atividade-corrigida/${id || ':id'}`
export const USER_PROFILE_MENU = `${ROOT_PATH}/perfil-menu`
export const LEVEL_SEARCH_PAGE = (level?: string) =>
  `${ROOT_PATH}/level/${level || ':term'}`

// Modular paths
export const LIVROS_HOME_ROOT_PATH = `${ROOT_PATH}/livros`
export const JOURNEY_HOME_ROOT_PATH = `${ROOT_PATH}/journey`
export const ATUALIDADES_HOME_ROOT_PATH = `${ROOT_PATH}/atualidades`
export const INGLES_HOME_ROOT_PATH = `${ROOT_PATH}/ingles`
export const LER_ROOT_PATH = `${ROOT_PATH}/ler`
export const SENTIR_ROOT_PATH = `${ROOT_PATH}/sentir`
export const SENTIR_HOME_ROOT_PATH = `${SENTIR_ROOT_PATH}/conteudo`
export const SENTIR_DIARIO_HOME_ROOT_PATH = `${SENTIR_ROOT_PATH}/diario`
export const LER_HOME_ROOT_PATH = `${LER_ROOT_PATH}/livros`
export const LER_NOTICIAS_HOME_ROOT_PATH = `${LER_ROOT_PATH}/noticias`
export const LER_REVISTAS_E_JORNAIS_HOME_ROOT_PATH = `${LER_ROOT_PATH}/revistas-e-jornais`
export const LER_VIDEOS_HOME_ROOT_PATH = `${LER_ROOT_PATH}/videos`
export const LER_PODCASTS_HOME_ROOT_PATH = `${LER_ROOT_PATH}/podcasts`
export const LER_TRILHAS_HOME_ROOT_PATH = `${LER_ROOT_PATH}/trilhas`
export const LER_NEWSSTAND_ROOT_PATH = `${LER_ROOT_PATH}/banca`
export const COMUNICAR_HOME_ROOT_PATH = `${ROOT_PATH}/comunicar`
export const SHOW_SHELF = (id?: string | number) =>
  `${ROOT_PATH}/prateleira/${id || ':id'}`
export const SHOW_OLYMPICS_SHELF = `${ROOT_PATH}/prateleira/olimpiadas`
export const SHOW_EVENT_SHELF = (id?: string | number) =>
  `${ROOT_PATH}/prateleira/evento/${id || ':id'}`
export const SHOW_BIBLION_SHELF = (id?: string | number) =>
  `${ROOT_PATH}/prateleira/biblion/${id || ':id'}`
export const SHOW_ATUALIDADES_SHELF = (name?: string) =>
  `${ROOT_PATH}/prateleira/${name || ':name'}`
export const SHOW_SENTIR_SHELF = (id?: string | number) =>
  `${ROOT_PATH}/prateleira/${id || ':id'}`

export const STORY_TREE_PATH = ROOT_PATH + '/story-tree'

export const COMUNICAR_STORY_TREE_HOME_ROOT_PATH = `${STORY_TREE_PATH}/comunicar`

export const DEPRECATED_SHOW_SHELF = (id?: string | number) =>
  `${LIVROS_HOME_ROOT_PATH}/prateleira/${id || ':id'}`

export const DEPRECATED_SHOW_ATUALIDADES_SHELF = (name?: string) =>
  `${ATUALIDADES_HOME_ROOT_PATH}/prateleira/${name || ':name'}`

export const DEPRECATED_SHOW_SENTIR_SHELF = (id?: string | number) =>
  `${SENTIR_HOME_ROOT_PATH}/prateleira/${id || ':id'}`

export const SENTIR_EMOTION_JOURNAL = `${SENTIR_HOME_ROOT_PATH}/diario-de-emocoes`

// Agnostic Intermediate Page

export const DEPRECATED_ATUALIDADES_INTERMEDIATE_PATH = (id?: string) =>
  `${ROOT_PATH}/atualidades/editoria/${id || ':id'}`

export const DEPRECATED_LIVRO_MODULE_BASED_INTERMEDIATE_PATH = (
  slug?: string
) => `${ROOT_PATH}/:module/livro/${slug || ':slug'}`

export const BOOK_DETAILS_PATH_ROOT = `${ROOT_PATH}/livro`

export const INTERMEDIATE_DETAILS_BOOK_PATH = (slug?: string) =>
  `${BOOK_DETAILS_PATH_ROOT}/${slug || ':slug'}`

export const BIBLION_INTERMEDIATE_DETAILS_BOOK_PATH = (slug?: string) =>
  `/app-v2/book/intermediate/${slug || ':slug'}`

export const INTERMEDIATE_DETAILS_BOOKS_PATH = (slug?: string) =>
  `${ROOT_PATH}/livros/${slug || ':slug'}`

export const INTERMEDIATE_DETAILS_ARTICLE_PATH = (id?: string | number) =>
  `${ROOT_PATH}/editoria/${id || ':id'}`

export const INTERMEDIATE_DETAILS_ARTICLES_PATH = (id?: string | number) =>
  `${ROOT_PATH}/editorias/${id || ':id'}`

export const INTERMEDIATE_DETAILS_PATH_ARTICLE_READER = (
  id?: string | number
) => `${ROOT_PATH}/editoria/${id || ':id'}/ler`

export const DEPRECATED_ATUALIDADES_INTERMEDIATE_DETAILS_PATH_ARTICLE_READER = (
  id?: string | number
) => `${ROOT_PATH}/atualidades/editoria/${id || ':id'}/ler`

// Admin paths
// ADMIN route is being used in the cypress test, if it changes or is removed it is necessary to change the e2e test (frontend/cypress/e2e/AdminOnlyRoute.cy.js)
export const ADMIN_ROOT_PATH = ROOT_PATH + '/admin'
export const ADMIN_ROOT_PATH_MOBILE = ROOT_PATH + '/admin-mobile'
export const ACTIVITY_REPORT_PATH_MOBILE =
  ADMIN_ROOT_PATH_MOBILE + '/relatorio-atividades'
export const TASK_REPORT_PATH_MOBILE =
  ADMIN_ROOT_PATH_MOBILE + '/relatorio-tarefas'
export const APPLY_ACTIVITIES_PATH_MOBILE =
  ADMIN_ROOT_PATH_MOBILE + '/aplicar-atividades'
export const APPLY_ACTIVITY_PATH_MOBILE = (activityId?: string) =>
  ADMIN_ROOT_PATH_MOBILE + `/aplicar-atividades/${activityId || ':id'}`
export const APPLY_ACTIVITY_FLOW_PATH_MOBILE = (activityId?: string) =>
  ADMIN_ROOT_PATH_MOBILE +
  `/aplicar-atividades/${activityId || ':id'}/pesquisar-alunos-e-entidades`
export const ENTITIES_AND_USERS_PATH_MOBILE =
  ADMIN_ROOT_PATH_MOBILE + '/turmas-e-usuarios'
export const ADMIN_MOBILE_ACTIVITIES_SHOW_ACTIVITY_PATH_V2 = (
  activityId?: string | number
) =>
  `${ADMIN_ROOT_PATH_MOBILE}/atividades/visualizar-v2/${
    activityId || ':activityId'
  }`

export const ADMIN_SUMMARY_PATH = ADMIN_ROOT_PATH + '/resumo'
export const ADMIN_SUMMARY_PATH_V2 = ADMIN_ROOT_PATH + '/resumo-v2'
export const ADMIN_SUMMARY_REPORT_V2_PATH = ADMIN_ROOT_PATH + '/resumo-v2'
export const ADMIN_SUMMARY_REPORT_V3_PATH = '/app-v2/admin/summary'
export const BIBLION_PANEL_PATH = '/app-v2/panel/catalog'
export const SEED_PANEL_PATH = '/app-v2/painel'
export const ADMIN_READING_REPORT_PATH = ADMIN_ROOT_PATH + '/reading-report'
export const READING_REPORTS_V2_PATH = ADMIN_ROOT_PATH + '/relatorios/leitura'
export const READING_REPORTS_V2_USER_VIEW_PATH = (readerId?: string) =>
  ADMIN_ROOT_PATH + `/relatorios/leitura/usuario/${readerId || ':readerId'}`
export const ADMIN_PUBLIC_ACTIVITIES_PATH_V2 =
  ADMIN_ROOT_PATH + '/atividades/atividades-publicas'

export const ADMIN_MANAGE_FEATURES =
  ADMIN_ROOT_PATH + '/gerenciar-funcionalidades'

export const ADMIN_BNCC_DIDACTIC_SEQUENCE_PATH =
  ROOT_PATH + '/admin/sequencias-didaticas'
export const ADMIN_BNCC_ALL_DIDACTIC_SEQUENCE_PATH =
  ROOT_PATH + '/admin/sequencias-didaticas/todas'
export const ADMIN_BNCC_MY_DIDACTIC_SEQUENCE_PATH =
  ROOT_PATH + '/admin/sequencias-didaticas/minhas'
export const ADMIN_BNCC_DIDACTIC_SEQUENCE_INFO_PATH =
  ROOT_PATH + '/admin/sequencias-didaticas/duvidas'
export const ADMIN_BNCC_DIDACTIC_SEQUENCE_DETAILS_PATH = (
  id?: string | number
) => `${ROOT_PATH}/admin/sequencias-didaticas/detalhes/${id || ':id'}`

// ADMIN_REPORTS route is being used in the cypress test, if it changes or is removed it is necessary to change the e2e test (frontend/cypress/e2e/smokeTeacher.cy.js)
export const ADMIN_REPORTS_PATH = ROOT_PATH + '/admin/relatorios'
export const ADMIN_ACTIVITIES_REPORT_PATH =
  ROOT_PATH + '/admin/relatorios/atividade'

export const ADMIN_TASK_DETAILS_PATH = (taskId?: string | number) =>
  `${ROOT_PATH}/admin/relatorios/tarefa/${taskId || ':taskId'}`

export const ADMIN_CLASS_REPORTS_PATH = (id?: string | number) =>
  `${ROOT_PATH}/admin/relatorios/turma/${id || ':id'}`
export const ADMIN_APPLIED_ACTIVITY_USERS_REPORT = (
  entityId?: string | number,
  activityId?: string | number
) =>
  `${ROOT_PATH}/admin/relatorios/turma/${entityId || ':entityId'}/atividade/${
    activityId || ':activityId'
  }`
export const ADMIN_STUDENT_REPORTS_PATH = (
  classId?: string | number,
  studentId?: string | number
) =>
  `${ROOT_PATH}/admin/relatorios/usuario/${classId || ':classId'}/${
    studentId || ':studentId'
  }`
export const ADMIN_BOOK_REPORTS_PATH = (
  classId?: string | number,
  bookSlug?: string
) =>
  `${ROOT_PATH}/admin/relatorios/livro/${classId || ':classId'}/${
    bookSlug || ':bookSlug'
  }`

export const ADMIN_ARTICLE_REPORTS_PATH = (
  classId?: string | number,
  articleId?: string | number
) =>
  `${ROOT_PATH}/admin/relatorios/artigo/${classId || ':classId'}/${
    articleId || ':articleId'
  }`

export const ADMIN_TIME_USAGE_REPORTS_PATH = ROOT_PATH + '/admin/tempo-de-uso'
export const ADMIN_ACCESS_REPORT_PATH =
  ADMIN_TIME_USAGE_REPORTS_PATH + '/relatorio-de-acesso'
export const ADMIN_READING_GOALS_REPORT_PATH =
  ADMIN_TIME_USAGE_REPORTS_PATH + '/relatorio-metas-de-leitura'
export const ADMIN_PAYMENTS_REPORT_PATH =
  ADMIN_TIME_USAGE_REPORTS_PATH + '/relatorio-de-pagamentos'
export const ADMIN_ENTITY_USERS_ONLINE_STATUS_PATH = `${ADMIN_TIME_USAGE_REPORTS_PATH}/acompanhamento-online`
export const ADMIN_ENTITY_USERS_ONLINE_STATUS_PATH_V2 = `${ADMIN_TIME_USAGE_REPORTS_PATH}/acompanhamento-online-v2`

// ADMIN_BOOK_INDICATION route is being used in the cypress test, if it changes or is removed it is necessary to change the e2e test (frontend/cypress/e2e/smokeTeacher.cy.js)

export const ADMIN_MANAGE_COLLECTION_PATH = `${ROOT_PATH}/admin/gerenciar-acervo`
export const ADMIN_BOOKS_MANAGEMENT_PATH = `${ROOT_PATH}/admin/gerenciar-acervo-v1`
// ADMIN_BOOK_INDICATION route is being used in the cypress test, if it changes or is removed it is necessary to change the e2e test (frontend/cypress/e2e/smokeTeacher.cy.js)
export const ADMIN_BOOK_INDICATION_PATH = `${ROOT_PATH}/admin/indicar-livro`
export const ADMIN_ENTITY_USERS_PATH = `${ROOT_PATH}/admin/turmas-usuarios`
export const ADMIN_ENTITY_USERS_V2_PATH = `${ADMIN_ENTITY_USERS_PATH}-v2`
export const ADMIN_USER_CARD_ID = (id?: string | number) =>
  `${ROOT_PATH}/admin/carteirinhas/usuario/${id || ':id'}`
export const ADMIN_ENTITY_CARD_ID = (id?: string | number) =>
  `${ROOT_PATH}/admin/carteirinhas/turma/${id || ':id'}`
export const ADMIN_ROOT_CARD_ID = (id?: string | number) =>
  `${ROOT_PATH}/admin/carteirinhas/escola/${id || ':id'}`
export const ADMIN_API_LIST = `${ROOT_PATH}/admin/apis`
export const ADMIN_API_FORM = (id?: string | number) =>
  `${ROOT_PATH}/admin/apis/${id || ':id'}`
export const ADMIN_ALL_BEST_READERS_CLASSES = `${ADMIN_ROOT_PATH}/turmas-que-mais-leram`
export const ADMIN_ALL_BEST_READERS = `${ADMIN_ROOT_PATH}/alunos-que-mais-leram`
export const ADMIN_LEAGUE_REPORT = `${ROOT_PATH}/admin/liga-de-leitores`
export const ADMIN_LEAGUE_REPORT_V2 = `${ADMIN_LEAGUE_REPORT}-v2`
export const ADMIN_JOB_POSITIONS_AND_PERMISSIONS = `${ROOT_PATH}/admin/cargos-e-permissoes`
export const ADMIN_SHELF_MANAGEMENT = `${ROOT_PATH}/admin/gerenciar-prateleiras`
export const ADMIN_SHELF_MANAGEMENT_CREATE = `${ROOT_PATH}/admin/gerenciar-prateleiras/criar`
export const ADMIN_SHELF_MANAGEMENT_EDIT = (id?: string | number) =>
  `${ROOT_PATH}/admin/gerenciar-prateleiras/editar/${id || ':id'}`
export const ADMIN_PROJECTS_WELCOME = ROOT_PATH + '/admin/bem-vindo'
export const ADMIN_READING_ASSESSMENT_HOME_V2 =
  ROOT_PATH + '/admin/fluencia-leitora-v2'
export const ADMIN_READING_FLUENCY_APP_V2 = '/app-v2/admin/reading-fluency'
export const ADMIN_SELECT_ENTITY_PATH = `${ROOT_PATH}/admin/selecionar-unidade`
export const READER_SELECT_CLASS_PATH = '/app-v2/selecionar-turma'
export const SLIDER_ADMIN = `${ADMIN_ROOT_PATH}/slider-admin`

// BNCC ROUTES
export const ADMIN_BNCC_MANAGE_DIDACTIC_SEQUENCES_PATH = `${ROOT_PATH}/admin/bncc/gerenciar-sds`
export const ADMIN_BNCC_MANAGE_DIDACTIC_SEQUENCE_PATH = (
  id?: string | number
) => `${ROOT_PATH}/admin/bncc/gerenciar-sds/${id || ':id'}`
export const ADMIN_BNCC_MANAGE_DIDACTIC_SEQUENCE_BASIC_INFOS_PATH = (
  id?: string | number
) => `${ROOT_PATH}/admin/bncc/gerenciar-sds/${id || ':id'}/informacoes-basicas`
export const ADMIN_BNCC_MANAGE_DIDACTIC_SEQUENCE_LESSONS_PATH = (
  id?: string | number
) => `${ROOT_PATH}/admin/bncc/gerenciar-sds/${id || ':id'}/aulas`
export const ADMIN_BNCC_MANAGE_DIDACTIC_SEQUENCE_ACTIVITIES_PATH = (
  id?: string | number
) => `${ROOT_PATH}/admin/bncc/gerenciar-sds/${id || ':id'}/atividades`
// END BNCC ROUTES

// Activities Routes
// ADMIN_REPORTS route is being used in the cypress test, if it changes or is removed it is necessary to change the e2e test (frontend/cypress/e2e/smokeTeacher.cy.js)
export const ADMIN_ACTIVITIES_HOME_PATH = `${ROOT_PATH}/admin/atividades`
export const ADMIN_ACTIVITIES_HOME_PATH_V2 = `${ROOT_PATH}/admin/catalogo-de-atividades`

export const ADMIN_ACTIVITIES_MY_ACTIVITIES_PATH = `${ROOT_PATH}/admin/atividades/minhas-atividades`
export const ADMIN_ACTIVITIES_APPLIED_ACTIVITIES_PATH = `${ROOT_PATH}/admin/atividades/atividades-aplicadas`
export const ADMIN_PUBLIC_ACTIVITIES_PATH_V1 = `${ROOT_PATH}/admin/atividades/atividades-publica`

export const ADMIN_ACTIVITIES_CREATE_ACTIVITY_PATH = `${ROOT_PATH}/admin/atividades/criar`
export const ADMIN_ACTIVITIES_CREATE_ACTIVITY_SIMPLE_PATH = (slug?: string) =>
  `${ADMIN_ACTIVITIES_CREATE_ACTIVITY_PATH}/${slug || ':slug'}`

export const ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH = (
  activityId?: string | number
) => `${ROOT_PATH}/admin/atividades/visualizar/${activityId || ':activityId'}`

export const ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH_V2 = (
  activityId?: string | number
) =>
  `${ROOT_PATH}/admin/atividades/visualizar-v2/${activityId || ':activityId'}`

export const ADMIN_ACTIVITIES_VIEW_ACTIVITY_PATH_V2 = (
  activityId?: string | number
) =>
  `${ROOT_PATH}/admin-v2/atividades/visualizar/${activityId || ':activityId'}`

export const ADMIN_ACTIVITIES_SHOW_ACTIVITY_SIMPLE_PATH = (
  activityId?: string | number,
  slugOrId?: string | number
) => `${ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH(activityId)}/${slugOrId || ':slug'}`

export const ADMIN_ACTIVITIES_SHOW_ACTIVITY_SIMPLE_PATH_V2 = (
  activityId?: string | number,
  slugOrId?: string | number
) =>
  `${ADMIN_ACTIVITIES_SHOW_ACTIVITY_PATH_V2(activityId)}/${slugOrId || ':slug'}`

export const ADMIN_ACTIVITIES_EDIT_ACTIVITY_PATH = (id?: string | number) =>
  `${ROOT_PATH}/admin/atividades/editar/${id || ':id'}`
export const ADMIN_ACTIVITIES_SIMPLE_EDIT_ACTIVITY_PATH = (
  id?: string | number,
  slug?: string
) => `${ADMIN_ACTIVITIES_EDIT_ACTIVITY_PATH(id)}/${slug || ':slug'}`

export const ADMIN_ACTIVITIES_REVIEW_ACTIVITY_TEMPLATE_PATH = (
  id?: string | number
) => `${ROOT_PATH}/admin/atividades/revisar-modelo/${id || ':id'}`
export const ADMIN_ACTIVITIES_SIMPLE_REVIEW_ACTIVITY_TEMPLATE_PATH = (
  id?: string | number,
  slug?: string
) =>
  `${ROOT_PATH}/admin/atividades/revisar-modelo/${id || ':id'}/${
    slug || ':slug'
  }`

// Activities Apply Routes
export const ADMIN_ACTIVITIES_APPLY_ACTIVITY_PATH = (id?: string | number) =>
  `${ROOT_PATH}/admin/atividades/aplicar/${id || ':id'}`
export const ADMIN_ACTIVITIES_APPLY_ACTIVITY_SIMPLE_PATH = (
  id?: string | number,
  slugOrId?: string | number
) => `${ADMIN_ACTIVITIES_APPLY_ACTIVITY_PATH(id)}/${slugOrId || ':slug'}`

// Activities correction Routes
export const ADMIN_ACTIVITIES_APPLIED_ACTIVITY_PATH = (
  activityId?: string | number
) =>
  `${ROOT_PATH}/admin/atividades/atividades-aplicadas/${
    activityId || ':activityId'
  }`
export const ADMIN_ACTIVITIES_APPLIED_PER_CLASS_PATH = (
  activityId?: string | number
) =>
  `${ROOT_PATH}/admin/atividades/atividades-aplicadas/por-turma/${
    activityId || ':activityId'
  }`
export const ADMIN_ACTIVITIES_DETAIL_APPLIED_ACTIVITY_PATH = (
  activityId?: string | number,
  appliedActivityId?: string | number
) =>
  `${ROOT_PATH}/admin/atividades/atividades-aplicadas/${
    activityId || ':activityId'
  }/${appliedActivityId || ':appliedActivityId'}`
export const ADMIN_ACTIVITIES_CORRECT_ACTIVITY_PATH = (
  appliedActivityId?: string | number,
  readerId?: string | number
) =>
  `${ROOT_PATH}/admin/atividades/corrigir/${appliedActivityId || ':id'}/${
    readerId || ':readerId'
  }`

export const ADMIN_ACTIVITIES_CORRECT_ACTIVITY_PATH_V2 = (
  appliedActivityId?: string | number,
  readerId?: string | number
) =>
  `${ROOT_PATH}/admin/atividades/corrigir-v2/${
    appliedActivityId || ':appliedActivityId'
  }/${readerId || ':readerId'}`
export const ACTIVITIES_CORRECT_ACTIVITY_PATH_V2 = (
  appliedActivityId?: string | number,
  readerId?: string | number
) =>
  `${ROOT_PATH}/atividades/corrigido/${
    appliedActivityId || ':appliedActivityId'
  }/${readerId || ':readerId'}`

// Client Management
export const CLIENT_MANAGEMENT_CLIENTS = '/gerenciar/clientes'
export const CLIENT_MANAGEMENT_CLIENT_PAGE = (id?: string | number) =>
  `/gerenciar/clientes/${id || ':id'}`
export const CLIENT_MANAGEMENT_CLIENT_IMPORT_REGISTER = (
  id?: string | number
) => `/gerenciar/clientes/${id || ':id'}/cadastrar`
export const CLIENT_MANAGEMENT_CLIENT_IMPORT_REGROUP = (id?: string | number) =>
  `/gerenciar/clientes/${id || ':id'}/enturmar`
export const CLIENT_MANAGEMENT_CLIENT_IMPORT_MIGRATE = (id?: string | number) =>
  `/gerenciar/clientes/${id || ':id'}/migrar`

export const CLIENT_MANAGEMENT_CLIENT_CARD_ID = (id?: string | number) =>
  `/gerenciar/clientes/carteirinhas/${id || ':id'}`

export const CLIENT_MANAGEMENT_CONTRACTS = '/gerenciar/contratos'
export const CLIENT_MANAGEMENT_CONTRACTS_PAGE = (id?: string | number) =>
  `/gerenciar/contratos/${id || ':id'}`
export const CLIENT_MANAGEMENT_CONTRACTS_DETAILS_PAGE = (
  id?: string | number
) => `/gerenciar/contratos/${id || ':id'}?tab=detalhes`

export const CLIENT_MANAGEMENT_PROCESS = '/gerenciar/processos'
export const CLIENT_MANAGEMENT_REVIEW_PROCESS = (id?: string | number) =>
  `/gerenciar/revisar-processos/${id || ':id'}`
export const CLIENT_MANAGEMENT_CANCELED_PROCESS = (id?: string | number) =>
  `/gerenciar/processo-cancelado/${id || ':id'}`

// Content Management
export const CLIENT_MANAGEMENT_CONTENT = '/gerenciar/conteudo'
export const CLIENT_MANAGEMENT_CONTENT_PAGE = (id?: string | number) =>
  `/gerenciar/conteudo/${id || ':id'}`
export const CLIENT_MANAGEMENT_CREATE_CONTENT = '/gerenciar/conteudo/adicionar'

// Activities
export const CLIENT_MANAGEMENT_ACTIVITIES = '/gerenciar/atividades'
export const CLIENT_MANAGEMENT_EDIT_ACTIVITIES = (id?: string | number) =>
  `/gerenciar/atividade/${id || ':id'}`
export const CLIENT_MANAGEMENT_CREATE_ACTIVITIES = '/gerenciar/atividades/criar'

export const SCHOOL_ACCESS_BASE_URL = '/acesso-escola'
export const SCHOOL_NOT_FOUND = `${SCHOOL_ACCESS_BASE_URL}/escola-nao-encontrada`
export const SCHOOL_CONFIRMATION_LOGIN = (code?: string) =>
  `${SCHOOL_ACCESS_BASE_URL}/escola/${code || ':code'}`
export const SCHOOL_ACCESS_RETRIEVAL = (code?: string) =>
  `${SCHOOL_ACCESS_BASE_URL}/escola/${code || ':code'}/resgatar-acesso`
// Running Records
export const RUNNING_RECORDS_PATH = `${ROOT_PATH}/running-records`
export const ADMIN_RUNNING_RECORDS_REPORT_PATH = `${ADMIN_ROOT_PATH}/relatorio-running-records`
export const ADMIN_RUNNING_RECORDS_APPLY_PATH = `${ADMIN_ROOT_PATH}/relatorio-running-records/aplicar`

// Backoffice V2
export const BACKOFFICE_V2_ROOT_PATH = '/backoffice-v2'
export const BACKOFFICE_V2_2FA_PATH = `${BACKOFFICE_V2_ROOT_PATH}/2fa`
export const BOOST_FOREST_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/boost-forest`
export const MOVE_TO_ROOT_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/move-to-root`
export const EDIT_MANY_USERS_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/edit-many-users`
export const INSERT_BOOKS_TO_COLLECTIONS_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/books-to-collections`
export const ACTIVITY_BOOKS_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/activity-books`
export const BOOK_QUESTIONS_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/activity-books/:slug`
export const BOOK_PROCESSING_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/book-processing`
export const DEACTIVATE_MANY_CLIENTS_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/deactivate-many-clients`
export const BULK_READING_FLUENCY = `${BACKOFFICE_V2_ROOT_PATH}/bulk-reading-fluency`
export const IMPORT_BOOKS_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/import-books`
export const LIST_PUBLISHERS_MANAGEMENT = `${BACKOFFICE_V2_ROOT_PATH}/list-publishers`
export const BACKOFFICE_V2_LAYERS_ACTIVATION_EMAILS = `${BACKOFFICE_V2_ROOT_PATH}/layers-activation-emails`

export const CLIENT_MANAGEMENT_USERS = '/gerenciar/usuarios'
export const CLIENT_MANAGEMENT_USER_PAGE = (id?: string | number) =>
  `/gerenciar/usuarios/${id || ':id'}`
